import { render, staticRenderFns } from "./LoadingSide.vue?vue&type=template&id=3ecc2b8f&"
var script = {}
import style0 from "./LoadingSide.vue?vue&type=style&index=0&id=3ecc2b8f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports